export class PlanningUpdateComment {
    admin_comment: string;
}
